import React from "react";
import { Clock } from "lucide-react";
import Modal from "./Modal";

interface TimeSavedInfoModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  savedTimeMinutes: number;
}

const TimeSavedInfoModal: React.FC<TimeSavedInfoModalProps> = ({
  isOpen,
  setIsOpen,
  savedTimeMinutes,
}) => {
  const formattedTime =
    savedTimeMinutes < 60
      ? `${Math.round(savedTimeMinutes)} minutes`
      : `${Math.floor(savedTimeMinutes / 60)}h ${Math.round(savedTimeMinutes % 60)}m`;
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="flex items-center gap-3 mb-4">
        <div className="bg-purple-100 text-purple-600 p-2 rounded-lg">
          <Clock size={20} />
        </div>
        <h3 className="text-lg font-semibold text-gray-900">
          How we calculate time saved
        </h3>
      </div>
      <div className="text-sm text-gray-600 space-y-3">
        <p>
          <strong className="text-gray-900">
            We're giving you your day back.
          </strong>{" "}
          On average, it takes a human 90 minutes to manually process a single
          page. Every time you use our platform, we do that heavy lifting for you
          in seconds.
        </p>
        <p>
          <strong className="text-gray-900">Your impact.</strong> You've saved{" "}
          <strong className="text-gray-900">{formattedTime}</strong> with Data Revival so far. That’s time you can now spend on meaningful work
          instead of transcribing data.
        </p>
      </div>
    </Modal>
  );
};

export default TimeSavedInfoModal;
